var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkGradient(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6003 0C5.07749 0 0.600342 4.47705 0.600342 10V29C0.600342 30.6569 1.94349 32 3.60034 32C5.2572 32 6.60034 30.6569 6.60034 29V12C6.60034 8.68652 9.28664 6 12.6003 6H20.6003C23.914 6 26.6003 8.68652 26.6003 12V20C26.6003 23.3135 23.914 26 20.6003 26H16.4003C14.7435 26 13.4003 27.3431 13.4003 29C13.4003 30.6569 14.7435 32 16.4003 32H22.6003C28.1232 32 32.6003 27.5229 32.6003 22V10C32.6003 4.47705 28.1232 0 22.6003 0H10.6003Z",
    fill: "url(#paint0_linear_807_37787)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_807_37787",
    x1: 16.6003,
    y1: 0,
    x2: 16.6003,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA202B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.380208,
    stopColor: "#B93288"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB70FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkGradient);
export default __webpack_public_path__ + "static/media/dark_gradient.4904ea019c7e4c440324e302263c45ed.svg";
export { ForwardRef as ReactComponent };